import { useFetch } from 'hooks/useFetch/useFetch'
import { GUEST_ONLINE_DETAILS_URL } from 'my-purchases/constants/endpoints'
import type { NonNormalizedPurchaseDetails } from 'my-purchases/types/purchaseDetail'
import { url } from 'utils/url'

interface ValidateGuestLoginProps {
	orderId: string
	guestEmail: string
}

export const useGuestLogin = () => {
	const { fetcher } = useFetch()

	const validateGuestLogin = async ({
		orderId,
		guestEmail,
	}: ValidateGuestLoginProps) =>
		fetcher<NonNormalizedPurchaseDetails | null>({
			url: url(`${GUEST_ONLINE_DETAILS_URL}/${orderId.toUpperCase()}`),
			method: 'GET',
			extraHeaders: { 'x-guest-email': guestEmail },
		})

	return { validateGuestLogin }
}
